// Lower: Booleano que indica si quiero convertir el string primeramente a lowercase antes de capitalizar las primaras letras de cada palabra
export default function capitalize(str, lower) {
	if (!str || !str.length) return '';
	return (lower ? str.toLowerCase() : str).replace(/(?:^|\s)\S/g, function (a) {
		return a.toUpperCase();
	});
}
